import { BodyText, Box, Flex, RadioGroup, RadioTile } from "@utilitywarehouse/hearth-react";

import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { PrivacyNoticeAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { PrivacyNoticeDataTest } from "../constants";  
import PrivacyError from "../PrivacyError";

const PrivacyNotice: React.FC = () => {
  const { privacyNoticeAnswer, setPrivacyNoticeAnswer } = useVulnerabilityContext();
         
  const handleChange = ((value: string) => {
    setPrivacyNoticeAnswer(value as PrivacyNoticeAnswer)
  });
  
  return (
    <Flex direction="column" gap="150">
      <Box data-testid={PrivacyNoticeDataTest.PRIVACY_NOTICE_BLURB}> 
        <BodyText weight="semibold">
          Please confirm that you are happy for us to store the answers you provide to the following questions to allow us to provide any extra support you may need.
        </BodyText>
        <BodyText>
          Any answers you provide to these questions are covered by our privacy notice. Please take a moment to read this so that you understand how we use your personal information.
        </BodyText>
      </Box>

      <RadioGroup
        aria-label="confirm data-storage"
        name="confirm-data-storage-buttons-group"
        onValueChange={handleChange}
        value={privacyNoticeAnswer}
        contentWidth="100%"
      >
        <RadioTile
          label="Yes, I'm happy for my answers to be stored"
          value={PrivacyNoticeAnswer.Yes}
          data-testid={PrivacyNoticeDataTest.YES_BTN}
        />
        <RadioTile
          label="No, please don't store my answers"
          value={PrivacyNoticeAnswer.No}
          data-testid={PrivacyNoticeDataTest.NO_BTN}
        />
      </RadioGroup>

      {privacyNoticeAnswer === PrivacyNoticeAnswer.No  ? (
        <Box marginTop="350">
          <PrivacyError />
        </Box>
      ) : null }
    </Flex>
  );
};
  
export default PrivacyNotice;
  